import React, { useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from './components/ProtectedRoute'; // Assuming you have this component for protected routes
import InviteMembers from "./pages/InviteMembers";
import LandingPage from './pages/LandingPage';
import CreateAccount from './components/CreateAccount';
import LeagueNameSetup from "./pages/LeagueNameSetup";
import AccountCreateSuccess from "./pages/AccountCreateSuccess";
import LeagueFeaturesSetup from './pages/LeagueFeaturesSetup';
import CommissionerDashboard from './components/CommissionerDashboard';
import Polls from './pages/Polls';
import Keepers from './pages/Keepers';
import Players from './pages/Players';
import PrizePage from './pages/PrizePage';
import LeagueBuzz from './pages/LeagueBuzz';
import DraftResults from './pages/DraftResults';
import Unauthorized from './pages/Unauthorized';
import { UserProvider } from './UserContext'; // Assuming you have this context
import { LeagueProvider } from './utils/LeagueContext'; // Assuming you have this context

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "Fantasy League Central";
        metaDescription = "Home page for Fantasy League HQ.";
        break;
      case "/createaccount":
        title = "Create an account";
        metaDescription = "Create or login to your Fantasy League Central account.";
        break;
      case "/commissionerdash":
        title = "League dashboard";
        metaDescription = "View your league's rules and members.";
        break;        
      case "/leaguefeaturessetup":
        title = "";
        metaDescription = "";
        break;
      case "/leaguenamesetup":
        title = "League setup";
        metaDescription = "Give your league a name.";
        break;
      case "/accountcreatesuccess":
        title = "";
        metaDescription = "";
        break;
      case "/invitemembers":
        title = "Add members";
        metaDescription = "Invite members to your league.";
        break;
      case "/polls":
        title = "Draft date polls";
        metaDescription = "Create and manage polls to decide your league's draft date.";
        break;
      case "/keepers":
        title = "League keepers";
        metaDescription = "Track your league's keepers and keep your league members informed.";
        break;
      case "/players":
        title = "Player research";
        metaDescription = "Track players you want to target for your draft and during the season.";
        break;
      case "/prizes":
        title = "League Prizes";
        metaDescription = "Add, edit, or delete league prizes and track winners.";
        break;
      case "/buzz":
        title = "League Buzz";
        metaDescription = "AI-generated weekly content for your fantasy league.";
        break;
      case "/draft":
        title = "Draft Results";
        metaDescription = "View and import historical draft results for your league.";
        break;
      case "/unauthorized":
        title = "No access to league";
        metaDescription = "Not authorized to see the league page.";
        break;  
      default:
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector('head > meta[name="description"]');
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <UserProvider>
        <LeagueProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/createaccount" element={<CreateAccount />} />
            <Route path="/leaguefeaturessetup" element={<ProtectedRoute><LeagueFeaturesSetup /></ProtectedRoute>} />
            <Route path="/leaguenamesetup" element={<ProtectedRoute><LeagueNameSetup /></ProtectedRoute>} />
            <Route path="/accountcreatesuccess" element={<ProtectedRoute><AccountCreateSuccess /></ProtectedRoute>} />
            <Route path="/invitemembers" element={<ProtectedRoute><InviteMembers /></ProtectedRoute>} />
            <Route path="/commissionerdash/:leagueId?" element={<ProtectedRoute><CommissionerDashboard /></ProtectedRoute>} />
            <Route path="/polls/:leagueId?" element={<ProtectedRoute><Polls /></ProtectedRoute>} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/keepers/:leagueId?" element={<ProtectedRoute><Keepers /></ProtectedRoute>} />
            <Route path="/players" element={<ProtectedRoute><Players /></ProtectedRoute>} />
            <Route path="/unauthorized" element={<ProtectedRoute><Unauthorized /></ProtectedRoute>} />
            <Route path="/prizes/:leagueId?" element={<ProtectedRoute><PrizePage /></ProtectedRoute>} />
            <Route path="/buzz/:leagueId?" element={<ProtectedRoute><LeagueBuzz /></ProtectedRoute>} />
            <Route path="/draft/:leagueId?" element={<ProtectedRoute><DraftResults /></ProtectedRoute>} />
          </Routes>
        </LeagueProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
